export default {
  headerContent: {
    title: 'Generali Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta İş Yeri Sigortası',
    description: {
      title: 'Generali Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'Generali Sigorta iş yeri sigortası ile işletmenizde oluşacak hasarlara karşı güvence altındasınız!',
        'İş yeri sigortası işletmede oluşacak yangın, hırsızlık, sel ve su baskınları gibi risklere karşı koruma sağlamaktadır. Generali Sigorta’nın sağlamış olduğu koruma ile işletme zararları önlenerek sermayenize güvence sağlanır.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta İşyeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası teminatları 2’ye ayrılmaktadır. Bu teminatlar;',
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar:</u></em></strong>',
          subList: [
            'Yangın, yıldırım, infilâk (doğalgaz infilâkları dahil)',
            'Muhteviyat hırsızlık',
            'Kasa muhteviyatı '
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar:</u></em></strong>',
          subList: [
            'Dahili su',
            'Fırtına',
            'Duman',
            'Kara taşıtları',
            'Hava taşıtları',
            'Yer kayması',
            'Kar ağırlığı',
            'Grev-lokavt-kargaşalık-halk hareketleri ve kötü niyetli hareketler-terör',
            'Cam kırılması',
            'Enkaz kaldırma masrafları',
            'Enflasyon koruma',
            'Hukuksal koruma',
            'Eksik sigorta',
            'Kiracı ve komşuluk mali sorumluluk',
            'Kira kaybı',
            'Alternatif işyeri masrafları',
            'İş durması',
            'Kişisel eşyalar teminatı',
            'Ferdi kaza teminatı',
            'Generali işyeri yardım hizmetleridir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Generali Sigorta İşyeri (Paket) Sigortası İsteğe Bağlı Teminatlar Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'İşyeri deprem ve yanardağ püskürmesi,',
            'İşyeri sel ve su baskını teminatı,',
            'Elektronik cihaz teminatı',
            'Makine kırılması teminatı',
            'Üçüncü şahıs mali sorumluluk teminatı',
            'İşveren mali sorumluluk sigortası teminatı',
            'Taşınan para teminatı',
            'Emniyeti suistimal teminatıdır.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta İşyeri (Paket) Sigortası Asistans Hizmetleri Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Su tesisatı hizmeti',
            'Elektrik tesisatı hizmeti',
            'Cam işleri hizmeti',
            'Çilingir hizmeti',
            'Anahtar/kilit sorunu nedeniyle konut/işyeri içerisindeki şahısların kurtarılması',
            'Otelde konaklama',
            'Konut/işyerinin korunması ve gözetimi',
            'Hastanede yatma durumunda yardım',
            'Doktor ve ambulans gönderimi',
            'Sabit faturaların ödenmesi',
            'Öngörülmeyen dönüş',
            'Vefat halinde cenazenin nakli',
            'Pet-Line hizmeti',
            'Tıbbi bilgi & danışmanlık',
            'Rezervasyon hizmetleridir.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'İş yeri sigortası yaptırmak kanunen zorunlu değildir. Ancak işletmeler kendi istekleri doğrultusunda iş yerlerini güvence altına almak için yaptırabilirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İş Yeri Sigortasında Emtea Nedir?',
      content: [
        {
          paragraph:
            'Emtea iş yerinizin içerisinde satılmak üzere bulundurduğunuz eşya veya mallara verilen genel bir isimdir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası kapsamı poliçenize ekletmiş olduğunuz teminatlarla orantılıdır.',
          subList: null
        },
        {
          paragraph:
            'İş yeri sigortası genel olarak işletmenizin uğrayacağı maddi zararları güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Teminat Dışı Durumlar Neler?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan haller TSB tarafından yayınlanan genel şartlarda yer alan durumlara ek olarak poliçe teminatları arasında yer almayan teminatlardır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası poliçe tanzim edildiği gün Türkiye saati ile öğlen 12.00’da başlar.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta İşyeri Sigortası İçin Gerekli Bilgiler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortasının doğru düzenlenebilmesi için kesin olan bilgilere gerek vardır.',
          subList: null
        },
        {
          paragraph: 'İstenen belgeler;',
          subList: [
            'İşletme tüzel kişilik ise işletmenin vergi numarası,',
            'İşletme şahıs şirketi ise işyeri sahibi TC’si,',
            'İş yeri içerisinde bulunan emtea bedelleri,',
            'Dekorasyon ve demirbaş bedelleri,',
            'İş yerinde bulunan cam bedelleri,',
            'İş yeri yangın güvenlik önlemleri,',
            'İş yeri hırsızlık güvenlik önlemleri bilgileri istenmektedir.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta İşyeri Sigortası Alırken Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'İş yeri sigortası içeriğinde yazan emtea, demirbaş, dekorasyon ve cam bedelleri kontrol edilmelidir.',
            'İş yeri sigortası teminatlarının ve teminat limitlerinin yeterliliği değerlendirilmelidir.',
            'İşletme unvanının doğruluğu kontrol edilmelidir.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta İşyeri Paket Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası teminat bedelleri işletmenin faaliyet gösterdiği sektör, işletme büyüklüğü, işletme içerisinde bulunan dekorasyon ve emtea gibi birçok etken göz önüne alınarak belirlenmektedir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Kimler İşyeri Sigortası Yaptırmalıdır?',
      content: [
        {
          paragraph:
            'İş yeri sigortası isteğe bağlı olarak yaptırılan ve her hangi bir kurum, kişi, sektör kısıtlaması bulunmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Paket Sigortası Avantajlı Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası işletmenizi, çalışanlarınızı ve sizi karşılaşabileceğiniz riskler karşısında koruma altına alarak büyük çaplı maddi kayıpları önlemektedir. Olası risk durumlarının yaşanması sonucunda bütçenizi ve işinizi güvence altına alarak poliçe limitleri dâhilinde zararınızı karşılar. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Cam Kırılması Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigortası işyeri sigortası teminatları arasında yer alan cam kırılması teminatı iş yerinizde bulunan camların kazaen veya poliçede belirtilen sebeplerden dolayı kırılması riskine karşılık güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Hangi Riskleri Kapsamaz?',
      content: [
        {
          paragraph:
            'İş yeri sigortası TSB’nin belirtmiş olduğu riskleri ve teminat altına alınmamış riskleri kapsamaz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta İşyeri Adresi Değişirse İşyeri Sigortası Ne Olur?',
      content: [
        {
          paragraph:
            'İş yeri adres değişikliği oluşması durumunda adres değişikliği zeyli talep edebilirsiniz. Adres değişikliğinizi acentenize bildirerek zeyil düzenlenmesini yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Su Baskınını Karşılar Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası içerisinde sel ve su baskınları teminatı bulunması durumunda oluşan hasar poliçe limitleri kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortasında Çilingir Hizmeti Var Mı?',
      content: [
        {
          paragraph:
            'Generali Sigorta, anahtar unutulması veya farklı bir sebepten gerekli olan çilingir hizmetini asistans paketi limitleri dahilinde müşterilerine ücretsiz olarak sunmaktadır. Sunulan bu teminat almış olduğunuz teminatlara göre değişmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali İş Yeri Sigortası Muhasebeleştirilir Mi?',
      content: [
        {
          paragraph:
            'İş yeri sigortanızın bir nüshasını muhasebenize ileterek vergi matrahınızdan düşülmesini talep ederek vergi indiriminden yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'İş yeri sigortanızı Alokasko aracılığıyla hızlı ve kolay bir şekilde yaptırmanız mümkün.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden dolduracağınız başvuru formu veya 7/24 ulaşabileceğiniz çağrı merkezi ile sizin en uygun iş yeri sigortası teklifi alabilir, aldığınız teklifi değerlendirebilir ve poliçe satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Online İşyeri Sigortası Hesaplama Yapılır Mı?',
      content: [
        {
          paragraph:
            'İş yeri sigortası hesaplaması online olarak yapılabilmektedir. Fakat bazı sektörler için risk analizi gerekmektedir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta En Uygun İşyeri Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'İş yeri sigortası fiyatları belirtmiş olduğunuz emtea, dekorasyon, demirbaş bedelleri ve sigortalının istemiş olduğu teminatlara göre belirlenmektedir. Bu bağlamda net bir iş yeri sigortası fiyatı verilememektedir.',
          subList: null
        },
        {
          paragraph:
            'En uygun sigorta sizin ihtiyaçlarınızın tümüne yanıt verebilen sigortadır. Bu sebeple en doğru fiyatı değerlendirmek için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Hesaplama Adımları Nelerdir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası hesaplaması işletme boyutuna göre değişmektedir. Büyük ve orta ölçekli işletmelerde risk analizi yapılması gerekirken küçük ölçekli işletmeler için bedellerin belirli olması yeterlidir.',
          subList: null
        },
        {
          paragraph:
            'Emtea bedelleri belirlendikten sonra en uygun teminatlar seçilerek poliçe kapsamı belirlenir.',
          subList: null
        },
        {
          paragraph:
            'Poliçe kapsamının belirlenmesinin ardından “<strong>iş yeri sigortası fiyatı</strong>” belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'İşyeri Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'İş yeri teklifinizi her ihtiyacımıza cevap verebilen internetten alabilmeniz mümkündür.',
          subList: null
        },
        {
          paragraph:
            'Alokasko olarak siz değerli müşterilerimizin yorulmaması için iş yeri sigortanızı online olarak alabilmenizi sağlamaktayız.',
          subList: null
        },
        {
          paragraph:
            'Online teklif almak için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
